import React from "react";
import { Grid } from "@mui/material";

export default function CityFieldContainer({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <>
      <Grid className={`no-pad-right`} size={{ xs: 12, md: 8 }}>
        {children}
      </Grid>
    </>
  );
}
